import React from 'react';

const Privacy = () => (
  <div
    style={{
      maxWidth: 900,
      margin: '2rem auto',
      paddingTop: 'calc(env(safe-area-inset-top, 16px) + 80px)',
      fontFamily: 'Arial, sans-serif',
      paddingLeft: '16px',
      paddingRight: '16px',
    }}
  >
          <h1 style={{ color: '#e52e71' }}>Política de Privacidad</h1>
          <div style={{ marginBottom: '2rem' }}>
            <p><strong>Última actualización:</strong> {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
            <p>Esta Política de Privacidad describe cómo <strong>FIEFIA SL</strong> ("nosotros", "nos", "nuestro") recopila, utiliza y protege tu información personal cuando utilizas nuestro sitio web fotocarnetmadrid.com (el "Servicio").</p>
          </div>

          <div style={{ marginBottom: '2rem' }}>
            <h2>1. Responsable del Tratamiento</h2>
            <ul>
              <li><strong>Razón Social:</strong> FIEFIA SL</li>
              <li><strong>CIF:</strong> B23815418</li>
              <li><strong>Domicilio Social:</strong> PASEO ERMITA DEL SANTO, 40 - 1, 28011 MADRID, Madrid</li>
              <li><strong>Email:</strong> <a href="mailto:ayuda.fotopacasa@fiefia.es">ayuda.fotopacasa@fiefia.es</a></li>
            </ul>
          </div>

          <div style={{ marginBottom: '2rem' }}>
            <h2>2. Información que Recopilamos</h2>
            <p>Recopilamos los siguientes tipos de información:</p>
            <ul>
              <li><strong>Fotos que subes:</strong> Imágenes que proporcionas para procesar en fotos de carnet</li>
              <li><strong>Información de pago:</strong> Procesada a través de proveedores de pago de terceros (no almacenamos tus datos de pago completos)</li>
              <li><strong>Información de cuenta:</strong> IDs de usuario anónimos generados automáticamente para fines de autenticación</li>
              <li><strong>Datos de uso:</strong> Información sobre cómo usas nuestro sitio web, incluido tipo de dispositivo, navegador e IP</li>
              <li><strong>Información de contacto:</strong> Si nos contactas por email o formulario de contacto, recopilamos tu nombre, email y contenido del mensaje</li>
            </ul>
          </div>

          <div style={{ marginBottom: '2rem' }}>
            <h2>3. Cómo Utilizamos Tu Información</h2>
            <p>Utilizamos tu información para los siguientes fines:</p>
            <ul>
              <li>Para procesar y transformar tus fotos subidas según tus especificaciones</li>
              <li>Para proporcionar soporte al cliente y responder a tus consultas</li>
              <li>Para procesar pagos y completar transacciones</li>
              <li>Para mejorar nuestros servicios y funcionalidad del sitio web</li>
              <li>Para asegurar la seguridad y prevenir fraudes</li>
              <li>Para cumplir con obligaciones legales</li>
            </ul>
          </div>

          <div style={{ marginBottom: '2rem' }}>
            <h2>4. Base Legal para el Tratamiento</h2>
            <p>Bajo el Reglamento General de Protección de Datos (RGPD), procesamos tus datos personales basándonos en:</p>
            <ul>
              <li><strong>Ejecución de contrato:</strong> Procesamiento necesario para cumplir el servicio que solicitaste</li>
              <li><strong>Intereses legítimos:</strong> Mejorar nuestros servicios y asegurar la seguridad del sitio web</li>
              <li><strong>Obligación legal:</strong> Cumplir con leyes y regulaciones aplicables</li>
              <li><strong>Consentimiento:</strong> Cuando has proporcionado consentimiento explícito para actividades específicas de procesamiento</li>
            </ul>
          </div>

          <div style={{ marginBottom: '2rem' }}>
            <h2>5. Almacenamiento y Retención de Datos</h2>
            <ul>
              <li>Las imágenes subidas y procesadas se almacenan de forma segura en nuestros servidores</li>
              <li>Las imágenes se eliminan automáticamente de nuestros servidores después de 30 días de procesamiento, a menos que solicites eliminación antes</li>
              <li>Los registros de transacciones de pago se conservan según lo requerido por la ley (típicamente 5-7 años para fines fiscales y contables)</li>
              <li>Las solicitudes del formulario de contacto y correspondencia por email se conservan hasta 2 años para fines de servicio al cliente</li>
              <li>Los datos de uso anónimos pueden conservarse para fines analíticos</li>
            </ul>
          </div>

          <div style={{ marginBottom: '2rem' }}>
            <h2>6. Seguridad de Datos</h2>
            <p>Implementamos medidas técnicas y organizativas apropiadas para proteger tus datos personales:</p>
            <ul>
              <li>Transmisión segura de datos mediante cifrado SSL/TLS</li>
              <li>Almacenamiento cifrado de datos sensibles</li>
              <li>Evaluaciones y actualizaciones de seguridad regulares</li>
              <li>Acceso limitado a datos personales solo cuando sea necesario</li>
              <li>Sistemas de autenticación seguros</li>
            </ul>
            <p>Sin embargo, ningún método de transmisión por internet o almacenamiento electrónico es 100% seguro. Aunque nos esforzamos por proteger tus datos, no podemos garantizar seguridad absoluta.</p>
          </div>

          <div style={{ marginBottom: '2rem' }}>
            <h2>7. Tus Derechos (RGPD)</h2>
            <p>Bajo el RGPD, tienes los siguientes derechos respecto a tus datos personales:</p>
            <ul>
              <li><strong>Derecho de acceso:</strong> Puedes solicitar una copia de los datos personales que tenemos sobre ti</li>
              <li><strong>Derecho de rectificación:</strong> Puedes solicitar corrección de datos inexactos o incompletos</li>
              <li><strong>Derecho al olvido:</strong> Puedes solicitar eliminación de tus datos personales bajo ciertas circunstancias</li>
              <li><strong>Derecho a limitar el tratamiento:</strong> Puedes solicitar limitación de cómo procesamos tus datos</li>
              <li><strong>Derecho a la portabilidad:</strong> Puedes solicitar transferencia de tus datos a otro proveedor de servicios</li>
              <li><strong>Derecho de oposición:</strong> Puedes oponerte a ciertos tipos de procesamiento de datos</li>
              <li><strong>Derecho a retirar el consentimiento:</strong> Cuando el procesamiento se basa en consentimiento, puedes retirarlo en cualquier momento</li>
            </ul>
            <p>Para ejercer cualquiera de estos derechos, por favor contáctanos en <a href="mailto:ayuda.fotopacasa@fiefia.es">ayuda.fotopacasa@fiefia.es</a>. Responderemos a tu solicitud dentro de un mes.</p>
          </div>

          <div style={{ marginBottom: '2rem' }}>
            <h2>8. Cookies y Tecnologías de Seguimiento</h2>
            <p>Utilizamos cookies y tecnologías similares para:</p>
            <ul>
              <li>Mantener tu sesión y estado de autenticación</li>
              <li>Recordar tus preferencias</li>
              <li>Analizar el uso del sitio web y mejorar la funcionalidad</li>
            </ul>
            <p>Puedes controlar las cookies a través de la configuración de tu navegador. Sin embargo, deshabilitar las cookies puede limitar tu capacidad de usar ciertas funciones de nuestro sitio web.</p>
          </div>

          <div style={{ marginBottom: '2rem' }}>
            <h2>9. Servicios de Terceros</h2>
            <p>Utilizamos servicios de terceros que pueden procesar tus datos:</p>
            <ul>
              <li><strong>Procesadores de pago:</strong> Tu información de pago es procesada por proveedores de pago seguros de terceros. No almacenamos los datos completos de tu tarjeta de pago.</li>
              <li><strong>Almacenamiento en la nube:</strong> Tus imágenes se almacenan utilizando servicios de almacenamiento en la nube con medidas de seguridad apropiadas</li>
              <li><strong>Analíticas:</strong> Podemos usar servicios de análisis para entender el uso del sitio web, que pueden recopilar datos anonimizados</li>
            </ul>
            <p>Estos servicios de terceros tienen sus propias políticas de privacidad. Te recomendamos revisarlas para entender cómo manejan tus datos.</p>
          </div>

          <div style={{ marginBottom: '2rem' }}>
            <h2>10. Privacidad de Menores</h2>
            <p>Nuestro servicio no está dirigido a menores de 16 años. No recopilamos conscientemente información personal de menores de 16 años. Si eres padre o tutor y crees que tu hijo nos ha proporcionado información personal, por favor contáctanos inmediatamente. Si nos enteramos de que hemos recopilado información personal de un menor de 16 años, eliminaremos dicha información de inmediato.</p>
          </div>

          <div style={{ marginBottom: '2rem' }}>
            <h2>11. Transferencias Internacionales de Datos</h2>
            <p>Tus datos pueden ser procesados y almacenados en servidores ubicados dentro del Espacio Económico Europeo (EEE). Si los datos se transfieren fuera del EEE, nos aseguramos de que existan salvaguardas apropiadas para proteger tus datos de acuerdo con los requisitos del RGPD.</p>
          </div>

          <div style={{ marginBottom: '2rem' }}>
            <h2>12. Cambios en Esta Política de Privacidad</h2>
            <p>Podemos actualizar esta Política de Privacidad ocasionalmente. Te notificaremos cualquier cambio publicando la nueva Política de Privacidad en esta página y actualizando la fecha de "Última actualización". Los cambios significativos se comunicarán por email o un aviso destacado en nuestro sitio web.</p>
            <p>Tu uso continuado del Servicio después de que los cambios sean efectivos constituye aceptación de la Política de Privacidad actualizada.</p>
          </div>

          <div style={{ marginBottom: '2rem' }}>
            <h2>13. Delegado de Protección de Datos</h2>
            <p>Para preguntas, consultas o para ejercer tus derechos sobre protección de datos, por favor contáctanos en:</p>
            <ul>
              <li><strong>Email:</strong> <a href="mailto:ayuda.fotopacasa@fiefia.es">ayuda.fotopacasa@fiefia.es</a></li>
            </ul>
          </div>

          <div style={{ marginBottom: '2rem' }}>
            <h2>14. Autoridad Supervisora</h2>
            <p>Si no estás satisfecho con cómo manejamos tus datos personales, tienes derecho a presentar una queja ante la Agencia Española de Protección de Datos (AEPD):</p>
            <ul>
              <li><strong>Sitio web:</strong> <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer">www.aepd.es</a></li>
              <li><strong>Dirección:</strong> C/ Jorge Juan, 6, 28001 Madrid, España</li>
            </ul>
          </div>
  </div>
);

export default Privacy;
